/*
 * @Author: Jason
 * @Date: 2019-10-15 17:32:50
 * @version:
 * @LastEditors: Jason
 * @LastEditTime: 2019-10-31 18:55:41
 * @Descripttion:
 */
import axios from 'axios'
import { Indicator,MessageBox } from 'mint-ui'
import CryptoJS from 'crypto-js'



/*
* localstorage 存储对象
*/
let projectName = "ShengDaSXNHETCFW";
let ls = {
    setter:function(key, value, time) {
        var _key = projectName + "_" + key;
        localStorage.removeItem(_key);
        var isObject = value instanceof Object,
          _time = new Date().getTime(),
          _age = time;

        // 如果不是对象，新建一个对象把 value 存起来
        if (!isObject) {
          var b = value;
          value = {};
          value._value = b;
        }
        // 加入时间
        value._time = _time;
        // 过期时间
        value._age = _time + _age;
        // 是否一个对象
        value._isObject = isObject;
        localStorage.setItem(_key, JSON.stringify(value));
        return this;
    },
    getter:function (key) {
        var _key = projectName + "_" + key;
        var isTimeout = function () {
          var isExpire = false,
            value = localStorage.getItem(_key),
            now = new Date().getTime();
          if (value) {
            value = JSON.parse(value);
            // 当前时间是否大于过期时间
            isExpire = now > value._age;
            console.log(now);
            console.log(value._age);
          } else {
            isExpire = true
            // 没有值也是过期
          }
          return isExpire;
        };
        var isExpire = isTimeout();
        var value = localStorage.getItem(_key);
        if (isExpire) {

            var _key = projectName + "_" + key;
            localStorage.removeItem(_key);
        } else {
          value = JSON.parse(value);
          value = value._value;
        }
        return value;
    },

    del:function (key) {
        var _key = projectName + "_" + key;
        localStorage.removeItem(_key);
    }
}


const baseUrlDomain = 'https://h5.schengle.com/ShengDaSXNHETC'
// const baseUrlDomain = 'http://h5-test.schengle.com/ShengDaSXNHETC'
const lsr = window.sessionStorage


function openLoading() {
    Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle' // 'snake''fading-circle''double-bounce''triple-bounce'
    })
}
function closeLoading() {
    Indicator.close()
}
// 加密
function encryptWord(word, keyStr) {
    keyStr = keyStr ? keyStr : 'NuBealJ0Ahl7eeY2'; // 判断是否存在ksy，不存在就用定义好的key
    var key = CryptoJS.enc.Utf8.parse(keyStr);
    var srcs = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return encrypted.toString();
}
// 解密
function decryptWord(word, keyStr) {
    keyStr = keyStr ? keyStr : 'NuBealJ0Ahl7eeY2';
    var key = CryptoJS.enc.Utf8.parse(keyStr);
    var decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}

var authorToken = ''
axios.defaults.baseURL = baseUrlDomain
axios.defaults.timeout = 15000

function GET(url, params) {
    axios.defaults.baseURL = baseUrlDomain
    // authorToken = ls.getter('loginStatus') || ''
    return axios.get(url, {
        params: params,
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(reqResult).catch(reqErr)
}

function POST(url, params, hasLoad = true, contentType = 'application/json') {
    axios.defaults.baseURL = baseUrlDomain
    if (hasLoad) {
        openLoading()
    }
    console.log('=====>',contentType)
    return axios
        .post(url, params, { headers: { 'Content-Type': contentType } })
        .then(reqResult)
        .catch(reqErr)
}
/**
 * 响应结果统一处理
 * @param {Object} res 响应的结果
 * @returns {Object} 响应结果的数据
 */
function reqResult(res) {
    let data = null
    console.log('成功',res)
    if (res.status === 200 && ( res.data.resultCode == '0000' || res.data.resultCode =='SUCCESS')) {
        data = res.data
    } else {
        throw res
    }
    closeLoading()
    return data
}
/**
 * 响应异常统一处理
 * @param {Object} 响应的异常
 */
function reqErr(e) {
    console.log('===执行失败===>', e)
    closeLoading()
    throw e.data

}

/*
* 时间格式化
* datetime:String,必须,要格式化的时间字符串
* format:String,可无,时间的格式(注意格式中对应的字母),默认为'yyyy-MM-dd HH:mm:ss' 全角ｍ表示英文月份
*/
function DateFormat(datetime, format = 'yyyy-MM-dd HH:mm:ss') {
let date = datetime
const month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
try {
    var o = {
    'ｍ+': month[date.getMonth()],
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'H+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(format)) format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    for (var k in o) {
    if (new RegExp('(' + k + ')').test(format)) format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
    }
    return format
} catch (e) {
    return datetime
}
}
function TimeFormat(datetime) {
    let subStr=new RegExp('-','ig');
    return datetime.replace(subStr,'/')
}


/*
* 检查各个数据的格式
*/
function Checking(value, type) {
    switch (type) {
        case 'carnum' :
            return /^[\u4E00-\u9FA5]{1}[A-Z]{1}[\da-zA-Z]{5,6}$/.test(value)
        case 'phone':
            return /^(\+?0?\d{1,3})-?\d{9,11}$/.test(value)
        case 'isEmail':
            return /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i.test(value)
    }
}
/*
* 获取URL地址栏携带的参数
*/
function GetQueryString(name){
    let url = window.document.location.toString()
    let arrObj = url.split('?')
    if (arrObj.length > 1) {
        let arrPara = arrObj[1].split('&')
        let arr
        for (let i = 0; i < arrPara.length; i++) {
        arr = arrPara[i].split('=')
        if (arr != null && arr[0] === name) {
            return arr[1]
        }
        }
        return ''
    } else {
        return ''
    }
}

// 获取定位
async function GetLoc(callback){
    openLoading()
    if (navigator.geolocation) {
        var _timeOut;
        _timeOut = setTimeout(function () {
            console.log('超时')
            closeLoading();
            getLocByIP(callback)
        }, 12000);
        var geolocation = new BMap.Geolocation();
        var geoc = new BMap.Geocoder();
        geolocation.getCurrentPosition(
            function (r) {
                closeLoading();
                clearTimeout(_timeOut);
                // 浏览器定位
                if (this.getStatus() == BMAP_STATUS_SUCCESS) {
                    geoc.getLocation(r.point, function (rs) {
                        var addComp = rs.addressComponents;
                        console.log('浏览器定位获取的定位信息', rs)
                        sessionStorage.longitude = rs.point.lng; //经度
                        sessionStorage.latitude = rs.point.lat; //纬度
                        sessionStorage.province = addComp.province; //省
                        sessionStorage.city = addComp.city; //城市
                        sessionStorage.myAddress = addComp.province + addComp.city + addComp.district + addComp.street +
                            addComp.streetNumber;
                        if( typeof callback == 'function') callback()
                        // return {
                        //     city: addComp.city,
                        //     province: addComp.province,
                        //     longitude = res.point.lng,
                        //     latitude = res.point.lat,
                        // }
                    });
                } else {
                    console.log('浏览器定位failed' , this.getStatus());
                    getLocByIP(callback)
                }
            }, {
                enableHighAccuracy: true,maximumAge: 0, timeout: 12000
            }
        );
    } else {
        closeLoading();
        console.log('浏览器不支持地理定位。');
        getLocByIP(callback)
    }

}

// ip定位
async function getLocByIP(callB) {
    var myCity = new BMap.LocalCity();
    myCity.get(function (result) {
        // 创建地理编码实例
        var myGeo = new BMap.Geocoder();
        // 根据坐标得到地址描述
        myGeo.getLocation(new BMap.Point(result.center.lng, result.center.lat), function (res) {
            console.log('IP获取的定位信息', res)
            closeLoading()
            var addComp = res.addressComponents;
            sessionStorage.longitude = res.point.lng; //经度
            sessionStorage.latitude = res.point.lat; //纬度
            sessionStorage.province = addComp.province; //省
            sessionStorage.city = addComp.city; //城市
            sessionStorage.myAddress = addComp.province + addComp.city + addComp.district + addComp.street +
                addComp.streetNumber;
            if( typeof callB == 'function') callB()
            // return {
            //     city: addComp.city,
            //     province: addComp.province,
            //     longitude = res.point.lng,
            //     latitude = res.point.lat,
            // }
        });
    });
}



/**
 * 判断是否在微信里打开
*/
function ISWX(){
    let u = window.navigator.userAgent
    return /micromessenger/.test(u.toLowerCase())
}

export { GET, POST,DateFormat,Checking,GetQueryString,TimeFormat,GetLoc,ls,ISWX, encryptWord, decryptWord }